import { ID, TaskFilterOptions } from '@griply/types';

// Tag/priority/duration have no goal analogue, so they admit every goal.
export const filterGoalsByFilterOptions = <T extends { id: ID }>(
  goals: T[],
  filterOptions: TaskFilterOptions[],
): T[] => {
  if (!filterOptions.length) {
    return goals;
  }

  return goals.filter((goal) =>
    filterOptions.some((filters) => {
      if (filters.goals?.length) {
        return filters.goals.includes(goal.id);
      }
      return !filters.noGoal;
    }),
  );
};
